import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Divider from '@zenbusiness/zui/Divider';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const ButtonStyle = ({ theme }) => ({
  height: '56px',
  width: '100%',
  marginTop: '16px',
  [theme.breakpoints.up('md')]: {
    width: '125px',
    whiteSpace: 'nowrap',
    marginTop: '32px'
  }
});

const BoxStyle = ({ theme }) => ({
  padding: '5px 13px',
  backgroundColor: theme.palette.background.cyan.light,
  width: 'fit-content',
  borderRadius: '12px'
});

const DividerStyle = ({ theme }) => ({
  marginTop: '8px',
  [theme.breakpoints.up('md')]: {
    marginTop: '16px'
  }
});

const ContentGridWrapperLeftStyle = ({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: '16px',
  gridTemplateAreas: `"contentLeft"
      "imageRight"`,
  [theme.breakpoints.up('md')]: {
    gridTemplateAreas: '"contentLeft imageRight"',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '12px'
  }
});

const ImageRightAreaStyle = ({ theme }) => ({
  gridArea: 'imageRight',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start'
  }
});

const ContentLeftAreaStyle = () => ({
  gridArea: 'contentLeft'
});

const ContentGridWrapperRightStyle = ({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: '16px',
  gridTemplateAreas: `"contentRight"
      "imageLeft"`,
  [theme.breakpoints.up('md')]: {
    gridTemplateAreas: '"imageLeft contentRight"',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '12px'
  }
});

const ImageLeftAreaStyle = ({ theme }) => ({
  gridArea: 'imageLeft',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start'
  }
});

const ContentRightStyle = () => ({
  gridArea: 'contentRight'
});

const BankingFeatureWrapperStyle = ({ theme }) => ({
  margin: 'auto',
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '2 / 12'
  }
});

const SharedAssetStyle = ({ theme }) => ({
  width: '80%',
  [theme.breakpoints.up('sm')]: {
    width: '50%'
  },
  [theme.breakpoints.up('md')]: {
    width: '100%'
  }
});

export const ButtonStyled = styled(Button)(ButtonStyle);
export const BoxStyled = styled(Box)(BoxStyle);
export const DividerStyled = styled(Divider)(DividerStyle);
export const ContentGridWrapperLeft = styled(Box)(ContentGridWrapperLeftStyle);
export const ImageRightArea = styled(Box)(ImageRightAreaStyle);
export const ContentLeftArea = styled(Stack)(ContentLeftAreaStyle);
export const ContentGridWrapperRight = styled(Box)(ContentGridWrapperRightStyle);
export const ImageLeftArea = styled(Box)(ImageLeftAreaStyle);
export const ContentRightArea = styled(Stack)(ContentRightStyle);
export const BankingFeatureWrapper = styled(Box)(BankingFeatureWrapperStyle);
export const SharedAssetStyled = styled(SharedAsset)(SharedAssetStyle);
